import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import './checkboxes-with-custom-input.css';
const CheckboxesWithCustomInput = ({ options, name, value, allowAdd = false, type = "checkbox", onChange }) => {
  // 🔹 Initialisation propre sans boucle infinie
  const initialSelectedOptions = type === "checkbox"
    ? (Array.isArray(value) ? value : value ? [value] : [])
    : value || ""; // Pour radio, stocke une seule valeur
  const initialCustomOptions = [...new Set([...options, ...(type === "checkbox" ? initialSelectedOptions : [initialSelectedOptions])])];
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);
  const [customOptions, setCustomOptions] = useState(initialCustomOptions);
  const [customInput, setCustomInput] = useState("");
  /**
   * 🛠️ Synchronisation des options sélectionnées (évite les boucles infinies)
   */
  useEffect(() => {
    let normalizedValue = type === "checkbox"
      ? (Array.isArray(value) ? value : value ? [value] : [])
      : value || "";
    if (JSON.stringify(selectedOptions) !== JSON.stringify(normalizedValue)) {
      setSelectedOptions(normalizedValue);
    }
  }, [value, type]);
  /**
   * 📌 Synchronisation des options disponibles sans créer de boucle infinie
   */
  useEffect(() => {
    const missingOptions = (type === "checkbox" ? selectedOptions : [selectedOptions])
      .filter(item => item && !customOptions.includes(item)); // ❌ Filtre les valeurs vides
    if (missingOptions.length > 0) {

      setCustomOptions(prev => [...prev, ...missingOptions]);
    }
  }, [selectedOptions]);
  /**
   * ✅ Mise à jour du parent (onChange) seulement si `selectedOptions` change
   */
  useEffect(() => {
    if (JSON.stringify(selectedOptions) !== JSON.stringify(value)) {
      onChange({ target: { name: name, value: selectedOptions } });
    }
  }, [selectedOptions]);
  /**
   * 🎯 Gestion du changement d'une checkbox ou d'un radio
   */
  const handleCheckboxChange = (optionValue) => {
    let updatedSelection;
    if (type === "checkbox") {
      const isSelected = selectedOptions.includes(optionValue);
      const isNoneSelected = /^aucun(e)?$/i.test(optionValue);
      if (isNoneSelected) {
        updatedSelection = [optionValue]; // Remplace tout par "aucun"
      } else {
        updatedSelection = isSelected
          ? selectedOptions.filter(item => item !== optionValue)
          : [...selectedOptions, optionValue];
        updatedSelection = updatedSelection.filter(item => !/^aucun(e)?$/i.test(item));
      }
    } else {
      updatedSelection = optionValue; // Pour les radios, simple sélection
    }
    setSelectedOptions(updatedSelection);
  };
  /**
   * ✨ Ajout d'une nouvelle option personnalisée
   */
  const handleAddCustomValue = () => {
    console.log('handleAddCustomValue')
    const trimmedInput = customInput.trim();
    if (trimmedInput && !customOptions.includes(trimmedInput)) {
      setCustomOptions(prev => [...prev, trimmedInput]);
    }
    if (type === "checkbox") {
      setSelectedOptions(prev => prev.includes(trimmedInput) ? prev : [...prev, trimmedInput]);
    } else {
      setSelectedOptions(trimmedInput);
    }
    setCustomInput(""); // Reset input
  };
  return (
    <div className="d-flex flex-column gap-1 mb-2 align-items-stretch checkboxes-with-custom-input">
      <div className="options">
        {customOptions.map((option, index) => (
          option.trim() !== '' && <div key={index} className="option">
            <label className="checkbox-label">
              <input
                type={type === 'radio' ? 'radio' : 'checkbox'}
                name={name}
                value={option}
                checked={type === "checkbox"
                  ? selectedOptions.includes(option)
                  : selectedOptions === option} // Vérification correcte pour les radios
                onChange={() => handleCheckboxChange(option)}
              />
              {option}
            </label>
          </div>
        ))}
      </div>
      {allowAdd &&
        <div className="input-group input-group-xs w-100" style={{ maxWidth: "240px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Ajouter une nouvelle valeur"
            value={customInput}
            onChange={(e) => setCustomInput(e.target.value)}
          />
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleAddCustomValue}
          >
            <FaPlus />
          </button>
        </div>
      }
    </div>
  );
};
export default CheckboxesWithCustomInput;
